export type Personality = 'whimsical' | 'professional';

export const DEFAULT_PERSONALITY: Personality = 'whimsical';
